// src/constants/CustomerConstants.js
export const GetAllCustomers_REQUEST = "GetAllCustomers_REQUEST";
export const GetAllCustomers_SUCCESS = "GetAllCustomers_SUCCESS";
export const GetAllCustomers_FAIL = "GetAllCustomers_FAIL";

export const GetCustomerByID_REQUEST = "GetCustomerByID_REQUEST";
export const GetCustomerByID_SUCCESS = "GetCustomerByID_SUCCESS";
export const GetCustomerByID_FAIL = "GetCustomerByID_FAIL";

export const AddCustomer_REQUEST = "AddCustomer_REQUEST";
export const AddCustomer_SUCCESS = "AddCustomer_SUCCESS";
export const AddCustomer_FAIL = "AddCustomer_FAIL";

export const SearchCustomersByEmail_REQUEST = "SearchCustomersByEmail_REQUEST";
export const SearchCustomersByEmail_SUCCESS = "SearchCustomersByEmail_SUCCESS";
export const SearchCustomersByEmail_FAIL = "SearchCustomersByEmail_FAIL";

export const UpdateCustomerDetails_REQUEST = "UpdateCustomerDetails_REQUEST";
export const UpdateCustomerDetails_SUCCESS = "UpdateCustomerDetails_SUCCESS";
export const UpdateCustomerDetails_FAIL = "UpdateCustomerDetails_FAIL";